const CHECK_PERMISSION_INIT = '@permissions/CHECK_PERMISSION_INIT';
const CHECK_PERMISSION_SUCCESS = '@permissions/CHECK_PERMISSION_SUCCESS';
const CHECK_PERMISSION_FAILURE = '@permissions/CHECK_PERMISSION_FAILURE';
const SET_IS_PERMISSION_CHECKED = '@permissions/SET_IS_PERMISSION_CHECKED';

export { CHECK_PERMISSION_INIT, CHECK_PERMISSION_SUCCESS, CHECK_PERMISSION_FAILURE, SET_IS_PERMISSION_CHECKED };
